
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ProcurementStatus } from '@/hooks/use-seller-procurements';

interface SellerProcurementStatusFilterProps {
  value: ProcurementStatus | 'all';
  onChange: (status: ProcurementStatus | 'all') => void;
}

const statusOptions: { value: ProcurementStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  { value: 'initiated', label: 'Initiated' },
  { value: 'pending', label: 'Pending' },
  { value: 'pending_finance', label: 'Pending Finance' },
  { value: 'awaiting_approval', label: 'Awaiting Approval' },
  { value: 'price_confirmed', label: 'Price Confirmed' },
  { value: 'quality_confirmed', label: 'Quality Confirmed' },
  { value: 'agreement_signed', label: 'Agreement Signed' },
  { value: 'pickup_scheduled', label: 'Pickup Scheduled' },
  { value: 'harvested', label: 'Harvested' },
  { value: 'in_transit', label: 'In Transit' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'completed', label: 'Completed' },
  { value: 'rejected', label: 'Rejected' },
];

const SellerProcurementStatusFilter: React.FC<SellerProcurementStatusFilterProps> = ({
  value,
  onChange
}) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[200px]">
        <SelectValue placeholder="Filter by status" />
      </SelectTrigger>
      <SelectContent>
        {statusOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SellerProcurementStatusFilter;
